export const NUM_ASSETS = 4;
